/**
 * Industry-standard trucking equipment taxonomy (mirrors API equipment-taxonomy.js).
 */

export const TRUCK_TYPE_OPTIONS = [
  { value: "class8_day_cab", label: "Class 8 — Day Cab" },
  { value: "class8_sleeper", label: "Class 8 — Sleeper" },
  { value: "class7_medium", label: "Class 7 — Medium Duty" },
  { value: "class6_box", label: "Box / Straight Truck" },
  { value: "dump", label: "Dump Truck" },
  { value: "mixer", label: "Cement Mixer" },
  { value: "tow", label: "Tow / Wrecker" },
  { value: "yard_spotter", label: "Yard Spotter (Yard Goat)" },
  { value: "other", label: "Other" },
];

export const TRAILER_TYPE_OPTIONS = [
  { value: "dry_van", label: "Dry Van" },
  { value: "reefer", label: "Refrigerated (Reefer)" },
  { value: "flatbed", label: "Flatbed" },
  { value: "step_deck", label: "Step Deck" },
  { value: "lowboy", label: "Lowboy" },
  { value: "double_drop", label: "Double Drop" },
  { value: "rgn", label: "RGN (Removable Gooseneck)" },
  { value: "tanker", label: "Tanker" },
  { value: "hopper", label: "Hopper / Pneumatic" },
  { value: "conestoga", label: "Conestoga" },
  { value: "pup", label: "Pup / Single Axle" },
  { value: "chassis", label: "Intermodal Chassis" },
  { value: "container", label: "Container (attached)" },
  { value: "other", label: "Other" },
];

export const CHASSIS_TYPE_OPTIONS = [
  { value: "chassis", label: "Intermodal Chassis" },
  { value: "other", label: "Other" },
];

const TYPE_OPTIONS_BY_CATEGORY = {
  truck: TRUCK_TYPE_OPTIONS,
  trailer: TRAILER_TYPE_OPTIONS,
  chassis: CHASSIS_TYPE_OPTIONS,
  forklift: [
    { value: "Electric", label: "Electric" },
    { value: "LPG/Gas", label: "LPG/Gas" },
    { value: "Diesel", label: "Diesel" },
    { value: "Reach Truck", label: "Reach Truck" },
    { value: "Pallet Jack", label: "Pallet Jack" },
    { value: "other", label: "Other" },
  ],
};

/**
 * @param {string} category
 * @returns {{ value: string, label: string }[]}
 */
export function getEquipmentTypeOptions(category) {
  return TYPE_OPTIONS_BY_CATEGORY[category] || [{ value: "other", label: "Other" }];
}

/**
 * @param {string} value
 * @returns {string}
 */
export function getEquipmentTypeLabel(value, category) {
  const options = getEquipmentTypeOptions(category);
  return options.find((option) => option.value === value)?.label || value;
}
